<template>
  <div>
    <b-card class="!tw-border-0" no-body>
      <b-tabs pills card vertical content-class="tw-p-0" nav-class="!tw-pb-8">
        <b-tab
          disabled
          title-link-class="tw-font-black"
          :title="$t('edit_campaign.email_template_group_title', 'Email Templates')"
        />
        <b-tab
          title-item-class="tw-ps-4"
          @click="changeEmailType('confirmation_email')"
          :title="$t('edit_campaign.email_template_confirmation', 'Donation confirmation')"
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <CampaignEmailTemplateSettings
              v-if="emailTemplates"
              :currentEmailType="currentEmailType"
              :showReceiptToggles="showReceiptToggles"
              :showBtns.sync="showBtns"
              :emailTemplate="emailTemplate"
              @change-image="onChangeImage"
              @show-edit-modal="showEditModal"
              @reset-all-template-to-default="resetAllTemplateToDefault"
            />
          </b-overlay>
        </b-tab>
        <b-tab
          active
          title-item-class="tw-ps-4"
          no-body
          @click="changeEmailType('receipt_email')"
          :title="$t('edit_campaign.email_template_receipt', 'Receipt email')"
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <b-card no-body>
              <b-tabs card justified content-class="tw-mt-3">
                <b-tab
                  v-if="emailTemplates"
                  :title="$t('edit_campaign.email_template_title', 'Email templates and settings')"
                  active
                >
                  <CampaignEmailTemplateSettings
                    :currentEmailType="currentEmailType"
                    :showReceiptToggles="showReceiptToggles"
                    :showBtns.sync="showBtns"
                    :emailTemplate="emailTemplate"
                    @change-image="onChangeImage"
                    @show-edit-modal="showEditModal"
                    @reset-all-template-to-default="resetAllTemplateToDefault"
                  />
                </b-tab>
                <b-tab
                  no-body
                  v-if="attachments.length"
                  :disabled="loadingEmailTemplates || updateEmail"
                  :title="$t('edit_campaign.receipt_preview', 'Receipts preview')"
                >
                  <div class="tw-flex tw-w-full tw-h-full tw-justify-center attachments-container">
                    <div v-for="atch in attachments" :key="atch.id">
                      <object :data="atch.src" type="application/pdf">
                        <iframe
                          :src="`https://docs.google.com/viewer?url=${atch.src}&embedded=true`"
                        ></iframe>
                      </object>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-overlay>
        </b-tab>
        <b-tab
          title-item-class="tw-ps-4"
          @click="changeEmailType('team_confirmation_email')"
          :title="
            $t('edit_campaign.email_template_team_confirmation_email', 'Team confirmation email')
          "
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <CampaignEmailTemplateSettings
              v-if="emailTemplates"
              :currentEmailType="currentEmailType"
              :showReceiptToggles="showReceiptToggles"
              :showBtns.sync="showBtns"
              :emailTemplate="emailTemplate"
              @change-image="onChangeImage"
              @show-edit-modal="showEditModal"
              @reset-all-template-to-default="resetAllTemplateToDefault"
            />
          </b-overlay>
        </b-tab>
        <b-tab
          title-item-class="tw-ps-4"
          @click="changeEmailType('donation_success_invite_friends_email')"
          :title="
            $t(
              'edit_campaign.email_template_donation_success_invite_friends_email',
              'Donation success invite friends email'
            )
          "
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <CampaignEmailTemplateSettings
              v-if="emailTemplates"
              :currentEmailType="currentEmailType"
              :showReceiptToggles="false"
              :showBtns.sync="showBtns"
              :emailTemplate="emailTemplate"
              @change-image="onChangeImage"
              @show-edit-modal="showEditModal"
              @reset-all-template-to-default="resetAllTemplateToDefault"
            />
          </b-overlay>
        </b-tab>
        <b-tab
          title-item-class="tw-ps-4"
          @click="changeEmailType('email_to_matched_donor')"
          :title="
            $t('edit_campaign.email_template_email_to_matched_donor', 'Email to matched donor')
          "
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <CampaignEmailTemplateSettings
              v-if="emailTemplates"
              :currentEmailType="currentEmailType"
              :showReceiptToggles="false"
              :showBtns.sync="showBtns"
              :emailTemplate="emailTemplate"
              @change-image="onChangeImage"
              @show-edit-modal="showEditModal"
              @reset-all-template-to-default="resetAllTemplateToDefault"
            />
          </b-overlay>
        </b-tab>
        <b-tab
          title-item-class="tw-ps-4"
          @click="changeEmailType('notify_team_leaders_on_each_donation')"
          :title="
            $t(
              'edit_campaign.email_template_notify_team_leaders_on_each_donation',
              'Email to team leaders on each donation'
            )
          "
        >
          <b-overlay :show="loadingEmailTemplates || updateEmail" rounded="sm">
            <CampaignEmailTemplateSettings
              v-if="emailTemplates"
              :currentEmailType="currentEmailType"
              :showReceiptToggles="false"
              :showBtns.sync="showBtns"
              :emailTemplate="emailTemplate"
              @change-image="onChangeImage"
              @show-edit-modal="showEditModal"
              @reset-all-template-to-default="resetAllTemplateToDefault"
            />
          </b-overlay>
        </b-tab>
        <b-tab
          v-if="enabledSmsTypes.length > 0"
          disabled
          title-link-class="tw-font-black"
          :title="$t('edit_campaign.sms_template_group_title', 'SMS Templates')"
        />
        <b-tab
          v-for="type in enabledSmsTypes"
          :key="type"
          title-item-class="tw-ps-4"
          @click="changeSmsType(type)"
          :title="$t(smsTypesConfig[type].i18nKey, smsTypesConfig[type].i18nFallback || '')"
        >
          <b-overlay :show="loadingSmsTemplates || updateSms" rounded="sm">
            <CampaignSmsTemplateSettings
              :showBtns.sync="showBtns"
              :smsTemplate="smsTemplatesByType[type]?.attributes?.message"
              @show-edit-modal="
                () => {
                  currentSmsType = type;
                  showEditSmsModal();
                }
              "
              @reset-template-to-default="
                () => {
                  currentSmsType = type;
                  resetSmsTemplateToDefault();
                }
              "
              :showResetBtn="getShowResetBtn(type)"
            />
          </b-overlay>
        </b-tab>
      </b-tabs>
    </b-card>

    <CampaignEmailModal ref="emailModal" @save-email-template="updateContentTemplate" />
    <CampaignSmsModal ref="smsModal" @save-sms-template="updateSmsContentTemplate" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import router from "@/router";
import urls from "@/constants/urls.js";
import CampaignEmailModal from "./campaign-email-modal.vue";
import CampaignSmsModal from "./campaign-sms-modal.vue";
import CampaignEmailTemplateSettings from "./campaign-email-template-settings.vue";
import CampaignSmsTemplateSettings from "./campaign-sms-template-settings.vue";
import { useCampaignSettings } from "@/composables/campaign-settings";
import { defineComponent, del } from "vue";

export default defineComponent({
  name: "campaign-email-sms-template",

  setup() {
    const { updateSetting, getSetting } = useCampaignSettings();

    return {
      updateSetting,
      getSetting,
    };
  },

  data() {
    return {
      showBtns: false,
      updateEmail: false,
      updateSms: false,
      currentEmailType: "receipt_email",
      emailTemplateData: {
        data: {
          attributes: {
            custom_subject: "",
            custom_body: "",
          },
          relationships: {
            custom_content: [],
          },
        },
        included: [],
      },
      templateType: "",
      errors: [],
      currentSmsType: "publicnewteamcreated",
      smsTypesConfig: {
        publicnewteamcreated: {
          metaName: "send_sms_to_team_leaders_when_team_created",
          defaultTitle: "publicnewteamcreated",
          i18nKey: "edit_campaign.sms_template_new_teams_created",
          i18nFallback: "New teams created",
          storage: "id",
        },
        team_donation_notification: {
          metaName: "team_donation_notification_by_sms",
          defaultTitle: "team_donation_notification",
          i18nKey: "edit_campaign.sms_template_team_donation_notification",
          i18nFallback: "Team donation notification",
          storage: "inline",
        },
      },
      smsTemplateIdsByType: {
        publicnewteamcreated: null,
        team_donation_notification: null,
      },
      smsTemplatesByType: {},
      metasByType: {},
    };
  },

  components: {
    CampaignEmailModal,
    CampaignEmailTemplateSettings,
    CampaignSmsTemplateSettings,
    CampaignSmsModal,
  },

  created: function () {
    this.$store.dispatch("getEmailTemplates");
    this.$store.dispatch("getSmsTemplates");
    // load metas for all sms types
    Object.keys(this.smsTypesConfig).forEach((type) => {
      this.getSmsTemplateMetaSettings(this.smsTypesConfig[type].metaName);
    });
  },

  methods: {
    getLocalizedMetaValue(value, defaultValue = "") {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale];
        }
        if (Object.prototype.hasOwnProperty.call(value, "en")) {
          return value.en;
        }
        const firstKey = Object.keys(value)[0];
        return firstKey ? value[firstKey] : defaultValue;
      }
      if (value === undefined || value === null || value === "") {
        return defaultValue;
      }
      return value;
    },

    getLocalizedMetaValueStrict(value) {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        return value[this.locale];
      }
      return value;
    },

    hasLocalizedMetaValue(value) {
      const localized = this.getLocalizedMetaValueStrict(value);
      if (typeof localized === "string") {
        return localized.trim().length > 0;
      }
      return localized !== undefined && localized !== null && localized !== "";
    },

    buildLocalizedMetaValue(existingValue, newValue) {
      if (existingValue && typeof existingValue === "object" && !Array.isArray(existingValue)) {
        if (newValue === undefined || newValue === null || newValue === "") {
          delete existingValue[this.locale];
          return existingValue;
        }
        return { ...existingValue, [this.locale]: newValue };
      }

      const nextValue = {};
      if (existingValue !== undefined && existingValue !== null && this.locale !== "en") {
        nextValue.en = existingValue;
      }
      nextValue[this.locale] = newValue;
      return nextValue;
    },

    changeSmsType(val) {
      this.currentSmsType = val;
    },

    getShowResetBtn(type) {
      const storage = this.smsTypesConfig[type]?.storage || "id";
      if (storage === "inline") {
        const metaName = this.smsTypesConfig[type]?.metaName;
        const meta = this.metasByType[metaName];
        return this.hasLocalizedMetaValue(meta?.attributes?.meta_data?.sms_template);
      }
      const id = this.smsTemplateIdsByType[type];
      return id !== 0 && id !== null;
    },

    isSmsTypeEnabled(type) {
      const metaName = this.smsTypesConfig[type]?.metaName;
      const meta = this.metasByType[metaName];
      return Boolean(meta?.attributes?.meta_data?.value);
    },

    getSmsTemplateMetaSettings(metaName) {
      this.getSetting(
        {
          cid: this.selectedCampaign,
          oid: localStorage.getItem("orgId"),
          extraParams: {
            falback_to_meta_dir: 1,
          },
        },
        metaName
      )
        .then((setting) => {
          // save metas always, but work with template only if value === true
          if (setting && setting.id !== "0" && setting?.attributes?.meta_data) {
            this.metasByType = { ...this.metasByType, [metaName]: setting };

            if (setting?.attributes?.meta_data?.value !== true) {
              return; // disabled, tab not show
            }

            const smsType = Object.keys(this.smsTypesConfig).find(
              (t) => this.smsTypesConfig[t].metaName === metaName
            );
            if (!smsType) return;

            const storage = this.smsTypesConfig[smsType]?.storage || "id";
            const tplRaw = setting.attributes.meta_data.sms_template;

            if (storage === "inline") {
              this.smsTemplateIdsByType = {
                ...this.smsTemplateIdsByType,
                [smsType]: 0,
              };
              const inlineText = this.getLocalizedMetaValue(tplRaw, "");
              if (typeof inlineText === "string" && inlineText.trim().length > 0) {
                const defaultTitle = this.smsTypesConfig[smsType]?.defaultTitle || smsType;
                // Use inline text from meta directly
                this.smsTemplatesByType = {
                  ...this.smsTemplatesByType,
                  [smsType]: { attributes: { message: inlineText, title: defaultTitle } },
                };
                return;
              }
            } else {
              const localizedId = this.getLocalizedMetaValue(tplRaw, 0);
              const tplId =
                typeof localizedId === "string"
                  ? parseInt(localizedId, 10)
                  : Number(localizedId || 0);
              this.smsTemplateIdsByType = {
                ...this.smsTemplateIdsByType,
                [smsType]: isNaN(tplId) ? 0 : tplId,
              };

              if (!tplId || tplId === 0) {
                // Take default template by title from smsTypesConfig
                const { defaultTitle } = this.smsTypesConfig[smsType] || {};
                if (defaultTitle) {
                  const searched = (this.smsTemplates || []).find(
                    (template) =>
                      template.attributes?.title === defaultTitle &&
                      template.attributes?.campaign_id === 0
                  );
                  if (searched) {
                    this.smsTemplatesByType = {
                      ...this.smsTemplatesByType,
                      [smsType]: searched,
                    };
                  }
                }
                return;
              }

              this.getSmsTemplateById(tplId).then((data) => {
                if (data) {
                  this.smsTemplateIdsByType = {
                    ...this.smsTemplateIdsByType,
                    [smsType]: Number(data.id),
                  };
                  this.smsTemplatesByType = {
                    ...this.smsTemplatesByType,
                    [smsType]: data,
                  };
                }
              });
              return;
            }

            // For inline storage default: render by title
            // Take default template by title from smsTypesConfig
            const { defaultTitle } = this.smsTypesConfig[smsType] || {};
            if (defaultTitle) {
              const searched = (this.smsTemplates || []).find(
                (template) =>
                  template.attributes?.title === defaultTitle &&
                  template.attributes?.campaign_id === 0
              );
              if (searched) {
                this.smsTemplatesByType = {
                  ...this.smsTemplatesByType,
                  [smsType]: searched,
                };
              }
            }
            return;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },

    getSmsTemplateById(templateId) {
      const orgId = localStorage.getItem("orgId");
      const url = urls.getSmsTemplateById(orgId, templateId);

      this.updateSms = true;
      return axios
        .get(url)
        .then((response) => {
          if (response.data?.data?.id) {
            return response.data.data;
          }
          return null;
        })
        .catch((e) => {
          console.error(e);
          return null;
        })
        .finally(() => {
          this.updateSms = false;
        });
    },

    changeEmailType(val) {
      this.currentEmailType = val;
    },

    showEditModal() {
      this.$refs.emailModal.openModal(this.emailTemplateData);
    },

    showEditSmsModal() {
      this.$refs.smsModal.openModal(this.smsTemplatesByType[this.currentSmsType] || {});
    },

    updateContentTemplate(template) {
      this.emailTemplateData.data.attributes = template.attributes;
      this.emailTemplateData.data.relationships = template.relationships;
      this.emailTemplateData.included = template.included;

      this.$refs.emailModal.setErrors([]);
      this.updateTemplate();
    },

    updateSmsContentTemplate(template) {
      let data = template;
      const orgId = localStorage.getItem("orgId");
      data.attributes.org_customer_id = Number(orgId);
      data.attributes.campaign_id = Number(this.selectedCampaign);

      const url = urls.getSmsTemplate(orgId);
      const currentType = this.currentSmsType;
      const storage = this.smsTypesConfig[currentType]?.storage || "id";
      const currentId = this.smsTemplateIdsByType[currentType];
      this.updateSms = true;

      if (storage === "inline") {
        const message = data?.attributes?.message || "";
        this.updateSmsMetaForType(currentType, message);
        this.$refs.smsModal.hideModal();
        this.updateSms = false;
        return;
      }

      if (currentId === 0) {
        delete data.id;
        axios
          .post(url, { data })
          .then((response) => {
            if (response.data?.data?.id) {
              this.updateSmsMetaForType(currentType, Number(response.data.data.id));
              this.$refs.smsModal.hideModal();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.updateSms = false;
          });
      } else {
        axios
          .put(url + "/" + currentId, { data })
          .then((response) => {
            if (response.data?.data?.id) {
              this.$store.dispatch("getSmsTemplates");
              this.$refs.smsModal.hideModal();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.updateSms = false;
          });
      }
    },

    resetSmsTemplateToDefault() {
      const orgId = localStorage.getItem("orgId");
      const url = urls.getSmsTemplate(orgId);

      const currentType = this.currentSmsType;
      const storage = this.smsTypesConfig[currentType]?.storage || "id";
      const currentId = this.smsTemplateIdsByType[currentType];

      this.updateSms = true;

      if (storage === "inline") {
        this.updateSmsMetaForType(currentType, "");
        return;
      }

      axios
        .delete(url + "/" + currentId)
        .then(() => {
          this.updateSmsMetaForType(currentType, 0);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.updateSms = false;
        });
    },

    updateSmsMetaForType(smsType, value) {
      const { metaName } = this.smsTypesConfig[smsType];
      const meta = this.metasByType[metaName];
      if (!meta) return;

      this.updateSms = true;
      const storage = this.smsTypesConfig[smsType]?.storage || "id";
      const nextSmsTemplateValue =
        storage === "inline"
          ? this.buildLocalizedMetaValue(meta.attributes?.meta_data?.sms_template, value)
          : value;
      const nextMetaData = {
        ...meta.attributes?.meta_data,
        sms_template: nextSmsTemplateValue,
      };

      const updatedMeta = {
        ...meta,
        attributes: {
          ...meta.attributes,
          meta_data: nextMetaData,
        },
      };

      this.metasByType = { ...this.metasByType, [metaName]: updatedMeta };
      this.updateSetting(
        {
          cid: this.selectedCampaign,
          oid: localStorage.getItem("orgId"),
        },
        metaName,
        meta.id,
        nextMetaData
      )
        .then((setting) => {
          if (setting && setting.id !== "0" && setting?.attributes?.meta_data?.value) {
            if (storage === "inline") {
              const inlineTextRaw = setting.attributes.meta_data.sms_template;
              const inlineText = this.getLocalizedMetaValue(inlineTextRaw, "");
              let message = "";
              if (typeof inlineText === "string") {
                message = inlineText;
              } else if (typeof inlineText === "number") {
                message = String(inlineText);
              }
              const defaultTitle = this.smsTypesConfig[smsType]?.defaultTitle || smsType;
              this.smsTemplateIdsByType = { ...this.smsTemplateIdsByType, [smsType]: 0 };
              this.smsTemplatesByType = {
                ...this.smsTemplatesByType,
                [smsType]: { attributes: { message, title: defaultTitle } },
              };
            } else {
              const tplIdRaw = setting.attributes.meta_data.sms_template;
              const localizedId = this.getLocalizedMetaValue(tplIdRaw, 0);
              const tplId =
                typeof localizedId === "string"
                  ? parseInt(localizedId, 10)
                  : Number(localizedId || 0);
              this.smsTemplateIdsByType = {
                ...this.smsTemplateIdsByType,
                [smsType]: isNaN(tplId) ? 0 : tplId,
              };
            }
          }
          this.$store.dispatch("getSmsTemplates");
          this.getSmsTemplateMetaSettings(metaName);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.updateSms = false;
        });
    },

    showError(e_1) {
      if (e_1.response.data) {
        if (e_1.response.data.error) {
          this.errors.push(e_1.response.data.error);
        } else {
          this.errors.push(this.$t("template.error_default"));
        }
      } else {
        this.errors.push(this.$t("template.error_default"));
      }
    },

    onChangeImage(e) {
      this.processFile(e);
    },

    async processFile(e) {
      this.errors = [];

      let fileInput;

      if (e instanceof Blob) {
        fileInput = e;
      } else {
        fileInput = e.target.files[0];
      }

      if (fileInput != null) {
        this.load = true;
        this.loadingImage = true;
        this.updateEmail = true;

        let form_data = new FormData();

        form_data.append("file", fileInput);

        try {
          const response = await axios.post(urls.loadImageQuill, form_data);

          const [included] = this.emailTemplateData.included;
          included.attributes.src = response.data.src;

          this.updateTemplate();
        } catch (e_1) {
          this.showError(e_1);
        } finally {
          this.updateEmail = false;
          this.loadingImage = false;
          this.load = false;
        }
      }
    },

    resetAllTemplateToDefault() {
      let orgId = localStorage.getItem("orgId");
      const templateType = this.emailTemplateData.data.attributes.title;

      this.updateEmail = true;
      axios
        .delete(
          urls.resetAllEmailTemplateById
            .replace(":orgId", orgId)
            .replace(":campaignId", router.currentRoute.params.id)
            .replace(":templateType", templateType)
        )
        .then(() => {
          this.load = false;
          this.updateEmail = false;
          this.$store.dispatch("getEmailTemplates");
        })
        .catch((e) => {
          this.updateEmail = false;
          this.showError(e);
        });
    },

    updateTemplate() {
      this.updateEmail = true;

      let orgId = localStorage.getItem("orgId");

      axios
        .post(
          urls.emailTemplateById
            .replace(":orgId", orgId)
            .replace(":campaignId", router.currentRoute.params.id)
            .replace(":templateType", this.templateType),
          this.emailTemplateData
        )
        .then(() => {
          this.$refs.emailModal.hideModal();
          this.$store.dispatch("getEmailTemplates");

          this.load = false;
          this.updateEmail = false;
        })
        .catch((e) => {
          this.load = false;
          this.updateEmail = false;
          this.showError(e);
          this.$refs.emailModal.setErrors(this.errors);
        });
    },
  },

  computed: {
    ...mapState({
      emailTemplate() {
        const template = this.getTemplateBytype(this.currentEmailType);

        if (template) {
          this.templateType = template.attributes.title;
          return template;
        }
      },
      emailTemplates: (state) => state.campaign.emailTemplates,
      smsTemplates: (state) => state.campaign.smsTemplates,
      loadingEmailTemplates: (state) => state.campaign.loadingEmailTemplates,
      loadingSmsTemplates: (state) => state.campaign.loadingSmsTemplates,
      type: (state) => state.campaign.campaign.data.attributes.type,
      showReceiptToggles: (state) => state.featureHide.showReceiptToggles,
      selectedCampaign: (state) => state.dashboard.selectedCampaign,
      locale: (state) => state.i18n.locale,
    }),
    ...mapGetters(["getTemplateBytype"]),

    enabledSmsTypes() {
      return Object.keys(this.smsTypesConfig).filter((type) => {
        const metaName = this.smsTypesConfig[type]?.metaName;
        const meta = this.metasByType[metaName];
        return Boolean(meta?.attributes?.meta_data?.value);
      });
    },

    includedMap() {
      return this.emailTemplateData.included.reduce((res, el) => {
        res[`${el.id}_${el.type}`] = el.attributes;
        return res;
      }, {});
    },

    attachments() {
      return (this.emailTemplateData.data.relationships?.attachments?.data || []).map((el) => ({
        ...this.includedMap[`${el.id}_${el.type}`],
        id: el.id,
      }));
    },

    locale() {
      return "en"; // always en in backend
    },
  },

  watch: {
    emailTemplates({ included }) {
      this.emailTemplateData.included = [...included];
    },
    emailTemplate(templete) {
      this.emailTemplateData.data = Object.assign(this.emailTemplateData.data, templete);
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_vars.scss";

.attachments-container {
  & > div {
    width: 100%;
  }
  * object,
  * iframe {
    min-height: 1000px;
    height: 100%;
    width: 100%;
  }
}

.quill-editor .ql-container {
  height: 400px;
  position: relative;
}

.template {
  max-width: 600px;
  min-width: 500px;
  min-height: 200px;
  position: relative;
  img {
    max-width: 100% !important;
  }
  @media only screen and (min-width: 769px) {
    max-width: unset;
    min-width: unset;
    width: 100%;
  }
  @media only screen and (min-width: 769px) {
    * table {
      width: 100% !important;
    }
  }
}

.image-controll {
  position: relative;
  height: 30px;
  width: 30px;
  label {
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: #0084af;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 18px;
    &:hover {
      background-color: lighten(#0084af, 10%);
    }
  }

  .upload_new_file {
    background-image: url("../../../../assets/img/cloud_white.png");
    position: absolute;
    left: 0;
    top: 0;
  }
  .email-template-editor {
    .quill-editor .ql-container {
      height: 350px;
      position: relative;
    }
  }
  .email-template-editor .quill-editor .ql-container {
    height: 350px;
    position: relative;
  }
}

.email-type-btn {
  margin-bottom: 24px;
}

.reset-btn {
  margin-bottom: 24px;
}

.template-btn-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  .btn-wrap {
    margin: 5px 0;
  }
  label {
    margin: 0;
    cursor: pointer;
  }
}

.loadin-image {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 140px;
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ql-align-center {
  text-align: center;
}

.ql-align-left {
  text-align: left;
}

.ql-align-right {
  text-align: right;
}
</style>
